module.exports = __webpack_public_path__ + "img/banner.a75f4c53.png";